"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = doctorWatchers;
var _effects = require("redux-saga/effects");
var _sagas = require("../../../astercore/auth/login/redux/sagas");
var _utils = require("../../../common/utils/utils");
var api = _interopRequireWildcard(require("../api/doctor"));
var actions = _interopRequireWildcard(require("./actions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function* getDoctorFilterAPI(params) {
  try {
    const {
      queryParam,
      showLoader = true
    } = params.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.GET_DOCTOR_FILTER_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.callDoctorFilterApi, queryParam, tokenData);
    yield (0, _effects.put)(actions.GET_DOCTOR_FILTER_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_DOCTOR_FILTER_API.failure(err));
    params.data.onFailure(err);
  }
}
function* getDoctorListAPI(params) {
  try {
    const {
      queryParam,
      showLoader = true
    } = params.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.GET_DOCTOR_LIST_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.callDoctorListApi, queryParam, tokenData);
    yield (0, _effects.put)(actions.GET_DOCTOR_LIST_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_DOCTOR_LIST_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getMyDoctorListAPI(params) {
  try {
    const {
      queryParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_MY_DOCTOR_LIST_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.callMyDoctorListApi, queryParam, tokenData);
    yield (0, _effects.put)(actions.GET_MY_DOCTOR_LIST_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_MY_DOCTOR_LIST_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getSpecialityDoctorListAPI(params) {
  try {
    const {
      queryParam,
      showLoader = true
    } = params.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.GET_SPECIALITY_DOCTOR_LIST_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.callSpecialityDoctorListApi, queryParam, tokenData);
    yield (0, _effects.put)(actions.GET_SPECIALITY_DOCTOR_LIST_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_SPECIALITY_DOCTOR_LIST_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getFacilityDoctorListAPI(params) {
  try {
    const {
      queryParam,
      showLoader = true
    } = params.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.GET_FACILITY_DOCTOR_LIST_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.callFacilityDoctorListApi, queryParam, tokenData);
    yield (0, _effects.put)(actions.GET_FACILITY_DOCTOR_LIST_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_FACILITY_DOCTOR_LIST_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getAllSpeialityListAPI(params) {
  const {
    queryParam
  } = params.data;
  try {
    yield (0, _effects.put)(actions.GET_ALL_SPECIALITY_LIST_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.callAllSpecialityListApi, queryParam, tokenData);
    yield (0, _effects.put)(actions.GET_ALL_SPECIALITY_LIST_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_ALL_SPECIALITY_LIST_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}

/*
    Request Params
    queryParam: {
      doctorId: doctor id,
      isFromRecentSearch: true/false
    }
*/

function* getDoctorDetailsAPI(params) {
  try {
    const {
      queryParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_DOCTOR_DETAILS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.callDoctorDetailsApi, queryParam, tokenData);
    yield (0, _effects.put)(actions.GET_DOCTOR_DETAILS_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_DOCTOR_DETAILS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getCmsDoctorDetailsAPI(params) {
  try {
    const {
      queryParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_CMS_DOCTOR_DETAILS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.callCmsDoctorDetailsApi, queryParam, tokenData);
    yield (0, _effects.put)(actions.GET_CMS_DOCTOR_DETAILS_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_CMS_DOCTOR_DETAILS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}

/*
    Request Params
    doctorId: dector's id to add or removed from favorite list
    isAddDoctor: if yes, it will call add doctor to favorite list else it will call remove doctor from favorite list
*/
function* addOrRemoveDoctorToFavorites(request) {
  try {
    const {
      doctorId,
      onSuccess,
      isAddDoctor = false
    } = request.data;
    yield (0, _effects.put)(actions.ADD_REMOVE_DOCTOR_API.request());
    let mainResponse;
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    if (isAddDoctor) {
      mainResponse = yield (0, _effects.call)(api.addDoctorToFavoritesApi, doctorId, tokenData);
    } else {
      mainResponse = yield (0, _effects.call)(api.removeDoctorFromFavoritesApi, doctorId, tokenData);
    }
    yield (0, _effects.put)(actions.ADD_REMOVE_DOCTOR_API.success(mainResponse));
    if (onSuccess) {
      var _mainResponse$message;
      onSuccess((_mainResponse$message = mainResponse.message) !== null && _mainResponse$message !== void 0 ? _mainResponse$message : '');
    }
  } catch (err) {
    yield (0, _effects.put)(actions.ADD_REMOVE_DOCTOR_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* getPastDoctorListAPI(params) {
  try {
    const {
      queryParam,
      showLoader = true
    } = params.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.GET_PAST_DOCTOR_LIST_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPastDoctorsList, queryParam, tokenData);
    yield (0, _effects.put)(actions.GET_PAST_DOCTOR_LIST_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PAST_DOCTOR_LIST_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getDoctorListSpecialityAPI(params) {
  try {
    const {
      queryParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_DOCTOR_LIST_SPECIALITY_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getDoctorListSpeciality, queryParam, tokenData);
    yield (0, _effects.put)(actions.GET_DOCTOR_LIST_SPECIALITY_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_DOCTOR_LIST_SPECIALITY_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getDoctorListFacilityAPI(params) {
  try {
    const {
      queryParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_DOCTOR_LIST_FACILITY_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getDoctorListFacility, queryParam, tokenData);
    yield (0, _effects.put)(actions.GET_DOCTOR_LIST_FACILITY_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_DOCTOR_LIST_FACILITY_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* doctorWatchers() {
  yield (0, _effects.takeLatest)(actions.GET_DOCTOR_FILTER, getDoctorFilterAPI);
  yield (0, _effects.takeEvery)(actions.GET_DOCTOR_LIST, getDoctorListAPI);
  yield (0, _effects.takeLatest)(actions.GET_MY_DOCTOR_LIST, getMyDoctorListAPI);
  yield (0, _effects.takeLatest)(actions.GET_SPECIALITY_DOCTOR_LIST, getSpecialityDoctorListAPI);
  yield (0, _effects.takeLatest)(actions.GET_FACILITY_DOCTOR_LIST, getFacilityDoctorListAPI);
  yield (0, _effects.takeLatest)(actions.GET_ALL_SPECIALITY_LIST, getAllSpeialityListAPI);
  yield (0, _effects.takeLatest)(actions.GET_DOCTOR_DETAILS, getDoctorDetailsAPI);
  yield (0, _effects.takeLatest)(actions.ADD_REMOVE_DOCTOR, addOrRemoveDoctorToFavorites);
  yield (0, _effects.takeLatest)(actions.GET_PAST_DOCTOR_LIST, getPastDoctorListAPI);
  yield (0, _effects.takeLatest)(actions.GET_CMS_DOCTOR_DETAILS, getCmsDoctorDetailsAPI);
  yield (0, _effects.takeLatest)(actions.GET_DOCTOR_LIST_SPECIALITY, getDoctorListSpecialityAPI);
  yield (0, _effects.takeLatest)(actions.GET_DOCTOR_LIST_FACILITY, getDoctorListFacilityAPI);
}